import stOpenBanking from './openBanking.component';
import stOpenBankingAssets from './openBankingAssets.component';
import stOpenBankingExpenses from './openBankingExpenses.component';
import stOpenBankingIncome from './openBankingIncome.component';
import stOpenBankingLiabilities from './openBankingLiabilities.component';

export default angular
  .module('st.Integrations.OpenBanking', [])
  .component('stOpenBanking', stOpenBanking)
  .component('stOpenBankingAssets', stOpenBankingAssets)
  .component('stOpenBankingExpenses', stOpenBankingExpenses)
  .component('stOpenBankingIncome', stOpenBankingIncome)
  .component('stOpenBankingLiabilities', stOpenBankingLiabilities)
  .service('openBankingService', ($q, $http, dataService, OPEN_BANKING) => ({
    getBasiqData: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        OPEN_BANKING.API.BASIQ_READ,
        { params },
        null
      )
  }))
  .constant('OPEN_BANKING', {
    API: {
      BASIQ_READ: '/api/v1/basiq/read'
    }
  });
